import { mainOutRoutes } from "./mainOut";
import { PageEnum } from "/@/enums/pageEnum";
import { t } from "/@/hooks/web/useI18n";
import { PAGE_NOT_FOUND_ROUTE, REDIRECT_ROUTE } from "/@/router/routes/basic";
import type { AppRouteRecordRaw } from "/@/router/types";
import { isDevMode } from "/@/utils/env";

export const asyncRoutes = [PAGE_NOT_FOUND_ROUTE];

export const RootRoute: AppRouteRecordRaw = {
  path: "/",
  name: "Root",
  redirect: PageEnum.BASE_HOME,
  meta: {
    title: "Root",
  },
};

export const LoginRoute: AppRouteRecordRaw = {
  path: "/login",
  name: "Login",
  component: () => import("/@/views/sys/login/Login.vue"),
  meta: {
    title: t("routes.basic.login"),
  },
};

// Basic routing without permission
const basicRoutes = [LoginRoute, RootRoute, ...mainOutRoutes, REDIRECT_ROUTE];

basicRoutes.push({
  path: "/guest/home",
  name: "gustHome",
  component: () => import("/@/views/guest/index.vue"),
  meta: {
    title: "分享链接",
    ignoreAuth: true,
  },
});

if (isDevMode()) {
  basicRoutes.push({
    path: "/playground",
    name: "Playground",
    component: () => import("/@/views/playground/index.vue"),
    meta: {
      title: "playground",
    },
  });
}

// 错误停发规则设置页 /settings/error-rules：
// dev 环境的菜单与路由由 mock/sys/menu.ts 的「设置」子菜单下发（含 errorRules 项），
// 走正常动态路由机制（与生产一致）——无需在此注册静态路由。
// 生产环境需后端把该路由记录写入菜单接口（详见 ROUTE-DELIVERY.md）。

export { basicRoutes };
